import React from "react";
import styles from "./Dropdown.module.scss";
import classNames from "classnames";

class Dropdown extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      focused: false,
      empty: true,
      selectType: "",
      children: false,
    };
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.haveChildren = this.haveChildren.bind(this);
  }

  onFocusHandler(event: any) {
    this.props.input.onFocus(event);
    this.setState({focused: true});

    if (this.props.onFocus !== undefined) {
      this.props.onFocus(event);
    }
  }

  onBlurHandler(event: any) {
    this.props.input.onBlur(event);
    this.setState({focused: false});

    if (this.props.onBlur !== undefined) {
      this.props.onBlur(event);
    }
  }

  haveChildren = () => {
    this.setState({children: !this.state.children});
  }

  onChangeHandler(event: any) {
    this.props.input.onChange(event);
    if (event.target.value === undefined || event.target.value.length === 0) {
      this.setState({empty: true});
    } else {
      this.setState({empty: false});
    }

    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  }

  getStyles() {
    let inputStyles = classNames(styles.Dropdown, styles.HideArrow, this.props.cssClassName);

    if (this.state.empty) {
      inputStyles = classNames(inputStyles, styles.DropdownEmpty);
    }

    if (this.state.focused) {
      inputStyles = classNames(inputStyles, styles.DropdownFocused);
    }

    if (this.props.meta ? (this.props.meta.touched && this.props.meta.error) : false) {
      inputStyles = classNames(inputStyles, styles.DropdownError);
    }
    if (this.props.disabled || this.props.cssClassName === "DropdownDisabled") {
      inputStyles = classNames(inputStyles, styles.DropdownDisabled);
    }

    if (this.props.textVisibility === "no-visible") {
      inputStyles = classNames(inputStyles, styles.LabelInvisible);
    }

    return inputStyles;
  }

  render() {
    let helpErrorText;
    if (this.props.meta && this.props.meta.touched && this.props.meta.error) {
      helpErrorText = <small>{this.props.meta.error}</small>;
    } else if (this.props.helpText) {
      helpErrorText = <small>{this.props.helpText}</small>;
    }

    let isReadOnlyIcon;
    let arrowStyle;
    if (this.props.readOnly) {
      arrowStyle = styles.HideArrow;
      isReadOnlyIcon = (
        <span
          className={classNames(
            styles.FieldIcon,
            styles.FieldIsReadOnly,
            "material-icons-outline"
          )}
        >
          https
        </span>
      );
    }

    return (
      <>
        {(!this.props.selectType || this.props.selectType === "default") &&
        <div className={this.getStyles()}>
          <label htmlFor={this.props.id}>{this.props.labelText}</label>
          <select
            id={this.props.id}
            {...this.props.input}
            {...this.props.rest}
            disabled={this.props.disabled}
            className={arrowStyle}
            onFocus={this.onFocusHandler}
            onBlur={this.onBlurHandler}
            onChange={this.onChangeHandler}>
            {this.props.children}
          </select>
          {isReadOnlyIcon}
          {helpErrorText}
        </div>
        }
        {this.props.selectType === "card" &&
        <div>
          <div className={classNames(styles.selectCard)}>
            <img onClick={this.haveChildren} src={require("../../../assets/img/icons/more-vertical.svg")} alt=""/>
          </div>

          {this.state.children &&
          <div>
            <div className={classNames(styles.Children)}>
              {this.props.children}
            </div>
          </div>
          }
        </div>
        }
      </>
    );

  }

}

export default Dropdown;
